var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"\n    flex flex-col\n    justify-center\n    align-center\n    px-2\n    bg-palette-neutral-10\n    key-border\n    rounded\n    drop-shadow\n    h-6\n  "},[_vm._v("\n  "+_vm._s(_vm.glyph)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }